import { onMounted, ref } from "vue";
import { fetchAgentAIIdentifiers } from "@/app/shared/services";

/**
 * Identificadores que ya pertenecen a un Agente IA, como mapa id -> nombre del agente.
 * `excludeBotId` deja fuera los del propio agente que se está editando.
 */
export function useAgentAIIdentifiers(excludeBotId?: () => number | undefined) {
  const blockedIdentifiers = ref<Record<number, string>>({});

  onMounted(async () => {
    try {
      const owners: Record<string, { bot_id: number; name: string }> = await fetchAgentAIIdentifiers();
      const botId = excludeBotId?.();

      blockedIdentifiers.value = Object.entries(owners).reduce((acc, [id, owner]) => {
        if (owner.bot_id !== botId) acc[Number(id)] = owner.name;
        return acc;
      }, {} as Record<number, string>);
    } catch (error) {
      // El backend también valida; sin datos no se bloquea nada en pantalla
      console.error(error);
    }
  });

  return { blockedIdentifiers };
}
